<template>
  <div class="sports_item" :style="{background:detail.tabstyle[0]['background']}">
    <!-- <Empty description="暂无数据"  /> -->
    <template v-if="subItemList.length>1">
      <div class="sports_item_body" v-if="+scoreType===1">
        <CellGroup :border="false">
          <div slot="title" class="sports_item_rule_img" @click="showRule=true">
            <VanImage
              :src="detail.introstyle['rule']['backgroundImage']"
              fit="cover"
              width="100%"
              height="100%"
            />
          </div>
          <Cell
            v-for="citem in subItemList"
            v-bind:key="citem.id"
            is-link
            center
            title-class="sports_item_title"
            :to="{name:'sportsDetail',params:{'sports_id':sports_id,'item_sub_id':citem.id}}"
          >
            <span
              slot="title"
              :style="{color:detail.tabstyle[2]['color'],'font-size':'.3rem'}"
            >• {{citem.title}}</span>
            <div slot="label" :style="{color:detail.tabstyle[2]['color'],'padding-left':'.3rem'}">
              <div>时间:{{citem.start_time_show}} ~ {{citem.end_time_show}}</div>
              <template  v-if="citem.desc">
                <Tag  :color="detail.tabstyle[0]['background']" :textColor="detail.tabstyle[1]['background']">{{citem.desc}}</Tag>
              </template>
            </div>
          </Cell>
        </CellGroup>
      </div>
      <div v-else-if="+scoreType===2" class="combine">
        <div class="combine_header" :style="{color:detail.tabstyle[2]['color']}">{{content}}</div>
        <div class="combine_body">
          <div v-for="citem in subItemList" :key="citem.id" :class="{attended:citem.attended}">
            <div>{{citem.start_time_week}} .</div>
            <van-icon name="success" v-if="citem.attended" />
            <div v-else>{{citem.start_time_day}}</div>
          </div>
        </div>
        <div class="combine_content" :style="{borderColor:detail.tabstyle[2]['color']}">
          <div v-html="rule" :style="{color:detail.tabstyle[2]['color']}"></div>
        </div>
        <div class="combine_footer">
          <Button
            size="small"
            round
            :to="{ name: 'sportsRank', params:{item_sub_id:0,sports_id:this.$route.params.id,item_id:this.$route.params.item_id}}"
            type="primary"
            block
            :color="detail.tabstyle[0]['color']"
            plain
          >打卡记录</Button>
          <Button
            size="small"
            round
            :to="{name:'sportsDetail',params:{'sports_id':sports_id,'item_sub_id':canjoin['id']}}"
            :disabled="!canjoin"
            type="warning"
            block
            :color="detail.tabstyle[0]['color']"
          >去看看</Button>
        </div>
      </div>
    </template>
    <template v-if="subItemList.length===1 || subItemList.length===0">
      <div
        class="rule"
        :style="{backgroundImage:`url(${detail.introstyle['body']['backgroundImage']})`}"
      >
        <div
          :style="{backgroundImage:`url(${detail.introstyle['header']['backgroundImage']})`,color:detail.tabstyle[1]['color']}"
          class="header"
        >{{title}}</div>
        <div class="html" v-html="rule" :style="{color:detail.tabstyle[2]['color']}"></div>
      </div>
    </template>
    <van-dialog
      v-model="showRule"
      class="sports_item_rule_dialog rule"
      :show-confirm-button="false"
      message-align="left"
      close-on-click-overlay
    >
      <van-icon
        name="close"
        style="position:fixed;right:10px;"
        size=".4rem"
        @click="showRule=false"
        :color="detail.tabstyle[0]['color']"
      />
      <div
        class="rule"
        :style="{backgroundImage:`url(${detail.introstyle['body']['backgroundImage']})`}"
      >
        <div
          :style="{backgroundImage:`url(${detail.introstyle['header']['backgroundImage']})`,color:detail.tabstyle[1]['color']}"
          class="header"
          slot="title"
        >{{title}}</div>
        <div v-html="rule"></div>
        <Button
            size="small"
            round
            type="warning"
            style="margin-top:1rem"
            block
            @click="showRule=false"
            :color="detail.tabstyle[0]['color']"
          >我已知晓</Button>
      </div>
    </van-dialog>
    <Button
      round
      :to="{name:'sportsDetail',params:{'sports_id':sports_id,'item_sub_id':subItemList[0]['id']}}"
      type="primary"
      block
      :color="buttonColor"
      v-if="enableActivity"
    >去看看</Button>
  </div>
</template>

<script>
import { Empty, Cell, CellGroup, Skeleton, Button, Image, Tag } from "vant";
import "./index.less";
export default {
  computed: {
    buttonColor() {
      let detail = this.detail;
      return detail.tabstyle[0]["color"];
    }
  },
  components: {
    Empty,
    Cell,
    CellGroup,
    Skeleton,
    Button,
    VanImage: Image,
    Tag,
  },
  props: ["item", "detail", "sports_id"],
  watch: {
    item: {
      handler: "getItemInfo",
      immediate: true,
      deep: true,
    },
  },
  data() {
    return {
      showRule: false,
      subItemList: [],
      title: "",
      rule: "",
      enableActivity: false,
      scoreType: 1,
      content: "",
      canjoin: "",
    };
  },
  methods: {
    getItemInfo() {
      this.subItemList = [];
      this.rule = "";
      this.$api.sports.getItemSubs({ itemid: this.item.id }).then((res) => {
        this.subItemList = res.data.list;
        this.title = res.data.title;
        this.content = res.data.content;
        this.rule = res.data.rule;
        this.scoreType = res.data.score_type;
        this.canjoin = res.data.canjoin;
        if (+res.data.list.length === 1) {
          let {
            title,
            start_time,
            end_time,
            vote_start_time,
            vote_end_time,
          } = res.data.list[0];
          this.title = title;
          this.enableActivity = res.sys_time > start_time;
        }
      });
    },
  },
};
</script>
